<template>
  <div class="catalog-layout">
    <div class="toolbar-container">
      <catalog-toolbar
        @openOptionsDialog="openOptionsDialog"
      />
    </div>
    <div class="components-container">
      <div class="tree-container">
        <v-toolbar dense flat v-if="!$vuetify.breakpoint.mdAndUp" color="secondary" dark>
          <v-toolbar-side-icon @click.stop="_toggleTreeSideBar" class="hidden-md-and-up"></v-toolbar-side-icon>
        </v-toolbar>
        <v-slide-y-transition>
          <div v-show="_treeSideBar || $vuetify.breakpoint.mdAndUp">
            <catalog-tree/>
          </div>
        </v-slide-y-transition>
      </div>
      <div class="table-container">
        <catalog-items
          @openOptionsDialog="openOptionsDialog"
        />
      </div>
    </div>
    <product-options
      ref="productOptions"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import CatalogToolbar from './CatalogToolbar'
import CatalogTree from './CatalogTree'
import CatalogItems from './CatalogItems'
import ProductOptions from '@/components/common/ProductOptions'

export default {
  name: 'catalog',
  components: {
    CatalogToolbar,
    CatalogTree,
    CatalogItems,
    ProductOptions
  },
  data () {
    return {
      treeSideBar: false
    }
  },
  computed: {
    ...mapGetters('catalog', {
      _emptyDocuments: 'emptyDocuments',
      _defaultDocument: 'defaultDocument',
      _currentDocument: 'currentDocument',
      _treeSideBar: 'treeSideBar'
    })
  },
  methods: {
    ...mapActions('catalog', {
      _loadDocuments: 'loadDocuments',
      _loadCurrentDocument: 'loadCurrentDocument',
      _setCurrentDocument: 'setCurrentDocument',
      _setCurrentFolderId: 'setCurrentFolderId',
      _toggleTreeSideBar: 'toggleTreeSideBar',
      _resetItemsTableContent: 'resetItemsTableContent',
      _updateDocName: 'updateDocName' // TODO temporary.
    }),
    openOptionsDialog (item) {
      this.$refs.productOptions.open(item, true, this._currentDocument.id, this._currentDocument.name === 'schet' ? 1 : 0)
    }
  },
  async beforeMount () {
    this._setCurrentFolderId(null)
    this._resetItemsTableContent()
    // load current document
    let params = this.$route.params
    const currentDocName = params.docName ? params.docName : this._emptyDocuments[this._defaultDocument].name
    this._updateDocName(currentDocName)
    if (params.docId && params.docName) {
      await this._loadCurrentDocument({
        id: params.docId,
        name: params.docName
      })
    } else {
      if (params.docName) {
        this._setCurrentDocument(JSON.parse(JSON.stringify(this._emptyDocuments[params.docName])))
        this.$router.push({
          name: `catalog/newDocument`,
          params: { docName: params.docName }
        })
      } else {
        this._setCurrentDocument(JSON.parse(JSON.stringify(this._emptyDocuments[this._defaultDocument])))
        this.$router.push({
          name: `catalog/newDocument`,
          params: { docName: this._defaultDocument }
        })
      }
    }
    await this._loadDocuments()
  }
}
</script>

<style lang="stylus" scoped>
  .catalog-layout {
    display flex
    flex-grow 1
    flex-direction column
    justify-content flex-start
    height: calc(100vh - 48px - 36px);
    @media screen and (max-width: 599px) {
      height: auto
    }
    @media screen and (min-width: 600px) and (max-width: 959px) {
      height: auto
    }

    .toolbar-container {
      flex-basis 48px
      @media screen and (min-width: 960px) {
        border-bottom: 1px solid #ccc
      }
    }

    .components-container {
      display flex
      flex-direction row
      flex-wrap wrap
      justify-content flex-start
      align-items flex-start
      flex-grow 1
      height: calc(100% - 49px);

      .tree-container {
        background white
        width: 350px
        height: 100%
        @media screen and (min-width: 960px) {
          border-right: 1px solid #ccc
        }
        @media screen and (max-width: 599px) {
          width: auto
          flex-grow 1
          height: auto
        }
        @media screen and (min-width: 600px) and (max-width: 959px) {
          width: auto
          flex-grow 1
          height: auto
          background white
        }
        @media screen and (min-width: 960px) and (max-width: 1263px) {
          width: 300px
        }

      }

      .table-container {
        background white
        height: 100%
        width: calc(100% - 350px)
        overflow auto
        flex-grow 0.5
        display flex
        flex-wrap nowrap
        justify-content flex-start
        @media screen and (max-width: 599px) {
          width: 100%
          height: auto
        }
        @media screen and (min-width: 600px) and (max-width: 959px) {
          width: 100%
          height: auto
        }
        @media screen and (min-width: 960px) and (max-width: 1263px) {
          width: calc(100% - 300px)
        }
      }
    }
  }

  .table-qty {
    border: 1px solid rgba(0, 0, 0, 0.12);
    width: 50px;
    margin: 0;
    text-align: right;
    padding: 5px;
    outline: none;
  }
</style>
